import { render } from "./CheckboxComponent.vue?vue&type=template&id=b86d5594&scoped=true&ts=true"
import script from "./CheckboxComponent.vue?vue&type=script&lang=ts"
export * from "./CheckboxComponent.vue?vue&type=script&lang=ts"

import "./CheckboxComponent.vue?vue&type=style&index=0&id=b86d5594&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86d5594"]])

export default __exports__